module.exports = __webpack_public_path__ + "static/media/4.515d05e4.png";